import { AxiosInstance } from 'axios';

export default class InstagramImageService {
    private axios: AxiosInstance;

    constructor(axios: AxiosInstance) {
        this.axios = axios;
    }

    public isValidImageUrl(url: string): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            const img = new Image();
            img.onload = () => {
                resolve(true);
            };

            img.onerror = () => {
                resolve(false);
            };

            img.src = url;
        });
    }
}
